import HeaderCalculator from "../../components/HeadrCalculator";
import EmptyCalculator from "../../components/EmptyCalculator";

export default function CalculatorEmptyPage(props) {
  const { statusMode, setStatusMode, isLoggedIn, showLogoutButton } = props;

  return (
    <>
      <HeaderCalculator
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
      />
      <EmptyCalculator statusMode={statusMode} isLoggedIn={isLoggedIn} />
    </>
  );
}
